export default "__VITE_ASSET__BSzUc_WA__"